(() => {
  const initialize = (widget) => {
    if (widget.dataset.initialized === 'true') return;
    widget.dataset.initialized = 'true';

    const form = widget.querySelector('[data-review-form]');
    const status = widget.querySelector('[data-review-status]');
    const count = widget.querySelector('[data-review-count]');
    const textarea = form?.elements?.text;
    const button = form?.querySelector('button[type="submit"]');
    const approvedReviews = widget.closest('.hey-testimonials-section')?.querySelector('[data-approved-reviews]');
    const apiBase = String(widget.dataset.apiUrl || '').replace(/\/$/, '');
    if (!form || !status || !textarea || !button || !apiBase) return;

    const updateCount = () => {
      count.textContent = `${textarea.value.length} / 1200`;
    };
    textarea.addEventListener('input', updateCount);
    updateCount();

    if (approvedReviews) {
      fetch(`${apiBase}/api/reviews`, { headers: { Accept: 'application/json' } })
        .then((response) => response.ok ? response.json() : Promise.reject())
        .then((result) => {
          (result.reviews || []).forEach((review) => {
            if (!review?.text) return;
            const quote = document.createElement('blockquote');
            quote.className = 'hey-testimonial';
            quote.setAttribute('role', 'listitem');
            const text = document.createElement('div');
            text.className = 'hey-testimonial__text';
            text.textContent = review.text;
            quote.appendChild(text);
            approvedReviews.appendChild(quote);
          });
        })
        .catch(() => {
          // Sabit yorumlar API geçici olarak kullanılamasa da görünmeye devam eder.
        });
    }

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      status.textContent = '';
      status.removeAttribute('data-state');

      if (!form.reportValidity()) return;

      button.disabled = true;
      button.textContent = 'Gönderiliyor…';
      try {
        const response = await fetch(`${apiBase}/api/reviews`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            text: textarea.value.trim(),
            website: form.elements.website.value,
            consent: form.elements.consent.checked,
          }),
        });
        const result = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(result.error || 'Yorum şu anda gönderilemiyor.');

        form.reset();
        updateCount();
        status.dataset.state = 'success';
        status.textContent = 'Teşekkür ederiz. Yorumunuz onay için Ayça’ya iletildi.';
      } catch (error) {
        status.dataset.state = 'error';
        status.textContent = error.message || 'Yorum şu anda gönderilemiyor. Lütfen daha sonra tekrar deneyin.';
      } finally {
        button.disabled = false;
        button.textContent = 'Gönder';
      }
    });
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll('[data-review-widget]').forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
